import { observer } from 'mobx-react';
import { currentUserStore } from '../../CurrentUserStore';
import { T } from '../../Translations';
import { useQueryWithDecoder } from '../../UseQueryWithDecoder';
import { ssoConfigurationsResourceDecoder } from './Decoders';
import Hub from './Hub';
import Loading from './Loading';
import PageLayout from './PageLayout';

function SingleSignOn() {
  const { data, isLoading, error } = useQueryWithDecoder(
    'sso-configurations',
    currentUserStore.links,
    ssoConfigurationsResourceDecoder,
  );

  return (
    <PageLayout>
      {isLoading ? (
        <Loading />
      ) : error || !data ? (
        <p className="text-muted-foreground">
          <T kind="An error occurred, please refresh the page and try again" />
        </p>
      ) : (
        <Hub resource={data} />
      )}
    </PageLayout>
  );
}

export default observer(SingleSignOn);
